import React, { useEffect, useState } from "react";
import Card from "../reusable/Card";
import ProfileDetails from "./ProfileDetails";
import ShadeBackgound from "../reusable/ShadeBackgound";
import ProfileIcon from "../../assets/icons/profile_icon.svg"
import { useConnectWallet, useWallets, useSetChain } from "@web3-onboard/react";

import { ethers } from "ethers";
function ProfileOption() {
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const [balance, setBalance] = useState(0)
  const [{ chains, connectedChain, settingChain }, setChain] = useSetChain();
  const [coinTicker, setCoinTicker] = useState("");

  async function getTokenTicker() {
    if (wallet) {
      try {

        switch ((connectedChain.id).toString()) {
          case "0x89": setCoinTicker("POL");
            break;
          case '0x38': setCoinTicker("BNB");
            break;
          case '0x1': setCoinTicker("ETH");
            break;
          case '0x1530': setCoinTicker("EDX");
            break;
        }
      } catch (error) {
        // console.log(error)
      }
    }
  }

  async function getBalance() {
    try {
      if (wallet?.accounts[0]?.address) {
        const provider = new ethers.providers.Web3Provider(
          wallet?.provider,
          'any'
        );
        const balance = await provider.getBalance(wallet?.accounts[0]?.address);
        setBalance(ethers.utils.formatEther(balance).slice(0, 5));

      }
    } catch (error) { }
  }
  useEffect(() => {
    getBalance()
    getTokenTicker()
  }, [wallet])

  return (
    <div>
      <div
        className="flex relative justify-center px-2"
        onClick={() => setProfileOpen(!isProfileOpen)}
      >
        <div className="pr-3 flex items-center">
          <img src={ProfileIcon} alt="profile" />
          {/* <div className="w-10 h-10 bg-orange-600 rounded-full"></div> */}
        </div>
        <div>
          {wallet && wallet.accounts && wallet.accounts.length > 0 ? (
            <>
              {wallet.accounts[0].address.slice(0, 4)}...{wallet.accounts[0].address.slice(-5)}
            </>
          ) : (
            "No wallet connected"
          )}
          <p className="text-xs">{balance} {coinTicker}</p>
        </div>
        {isProfileOpen && <ProfileDetails />}
      </div>
      {isProfileOpen && (
        <ShadeBackgound
          opacity={0.4}
          onClik={() => {
            if (isProfileOpen) {
              setProfileOpen(false);
            } else {
              return;
            }
          }}
        />
      )}
    </div>
  );
}

export default ProfileOption;
